export default "__VITE_ASSET__36f9fd72__"